var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 54,
    viewBox: "0 0 52 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.45 51.7999H8.94997C5.5258 51.7999 2.74998 49.0241 2.75 45.5999L2.75024 8.40004C2.75026 4.97589 5.52609 2.20007 8.95024 2.20007H36.8509C40.2751 2.20007 43.0509 4.97591 43.0509 8.40007V20.8001M46.15 47.1501L49.25 50.2501M13.601 14.6001H32.201M13.601 23.9001H32.201M13.601 33.2001H22.901M47.7 40.9501C47.7 45.2303 44.2302 48.7001 39.95 48.7001C35.6698 48.7001 32.2 45.2303 32.2 40.9501C32.2 36.6699 35.6698 33.2001 39.95 33.2001C44.2302 33.2001 47.7 36.6699 47.7 40.9501Z",
    stroke: "#00A1E4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon (2).56dabeeb473de62c85832061f6c7f4ce.svg";
export { ForwardRef as ReactComponent };